import React from 'react'
import { Toast } from 'antd-mobile';
import { baiduStatistics, baiduStatisticsBehaviour, formatMTime, getAllTime, getQueryString, jumpYYB } from '../../utils/utils'



export default class Download extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount(){
    baiduStatistics()
    //Toast.loading('正在加载...', 0)
    let label = getQueryString('label');
    let date = getQueryString('date');
    console.log("-------------"+label+"---------"+date);
    setTimeout(function () {
      baiduStatisticsBehaviour('APP下载', '跳转', label)
      jumpYYB(label, date);
    },500);
  }

  render() {
    return (
      <div>Download</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/download/index.js